import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import useSnackBars from '@fingo/lib/hooks/useSnackBars';
import UploadDropZoneDialogContainer from '@fingo/lib/components/containers/UploadDropZoneDialogContainer';
import INVOICE_UPLOAD_DROPZONE_CLASS_NAME from '@fingo/lib/theme/constants/upload-dropzone';
import {
  MAX_FILE_SIZE_BYTES,
  MAX_FILE_SIZE_MB,
  NOMINA_ACCEPT,
  NOMINA_ACCEPTED_EXTENSIONS,
} from '../../constants/upload-nomina';
import UploadNominaDropZoneContent from './UploadNominaDropZoneContent';

const UploadNominaDropZone = ({ files, setFiles }) => {
  const { addAlert } = useSnackBars();

  const handleReject = useCallback((fileRejections) => {
    const isTooLarge = fileRejections[0].errors.some((error) => error.code === 'file-too-large');
    if (isTooLarge) {
      addAlert({
        id: 'upload-nomina-rejected-file',
        message: `El archivo supera el tamaño máximo de ${MAX_FILE_SIZE_MB}MB`,
        severity: 'error',
      });
      return;
    }
    addAlert({
      id: 'upload-nomina-rejected-file',
      message: `Archivos permitidos: ${NOMINA_ACCEPTED_EXTENSIONS}`,
      severity: 'warning',
      color: 'warning',
    });
  }, [addAlert]);

  return (
    <UploadDropZoneDialogContainer
      files={files}
      setFiles={setFiles}
      accept={NOMINA_ACCEPT}
      maxSize={MAX_FILE_SIZE_BYTES}
      multiple={false}
      onReject={handleReject}
      className={INVOICE_UPLOAD_DROPZONE_CLASS_NAME}
      renderContent={UploadNominaDropZoneContent}
    />
  );
};

UploadNominaDropZone.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })).isRequired,
  setFiles: PropTypes.func.isRequired,
};

export default UploadNominaDropZone;
